import { useMutation } from "react-query";
import fetchAuth from "../services/fetchAuth";

function useLoginMutation() {
  return useMutation(["login"], fetchAuth);
}

export default useLoginMutation;
